import script from "./ChangeSku.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChangeSku.vue?vue&type=script&lang=ts&setup=true"

import "./ChangeSku.vue?vue&type=style&index=0&id=c3f77f28&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3f77f28"]])

export default __exports__